(function (app) {
    'use strict';
    var NG_REPEAT_REGEXP = /^\s*(.+)\s+in\s+([\r\n\s\S]*?)\s*(\s+track\s+by\s+(.+)\s*)?$/;
    var PAGE_DEFAULT_HEIGHT = 1200;
    // This padding is required for visible index calculation
    var HEADER_HEIGHT_PADDING = 10;
    app.directive('infiniteScroll', infiniteScroll);
    infiniteScroll.$inject = ['$compile', '$timeout', '$window', '$routeParams', 'reporting.dashboards.services.sideBarService'];
    function infiniteScroll($compile, $timeout, $window, $routeParams, sideBarService) {
        return {
            restrict: 'A',
            replace: true,
            template: function ($element, $attrs) {
                var repeater = parseRepeaterExpression($attrs.infiniteScroll);
                var oldAttrs = Array.prototype.slice.call($element.prop('attributes'), 0);
                var ngRepeat = 'itemHolder in subItems track by (itemHolder.parentIndex' +
                    (repeater.trackBy ?
                        ' + ' + repeater.trackBy.replace(repeater.item, 'itemHolder.item') + ')' :
                        ')');
                var newEl = $element.clone();
                angular.forEach(oldAttrs, function (attr) {
                    if (attr.name !== 'ng-model') {
                        newEl.removeAttr(attr.name);
                    }
                });
                newEl.attr('ng-repeat', ngRepeat);
                newEl.attr('ng-init', repeater.item + ' = itemHolder.item');
                newEl.attr('ng-class', '{\'first-item\':$first}');
                return newEl.prop('outerHTML');
            },
            link: function ($scope, $element, $attrs) {
                var repeater = parseRepeaterExpression($attrs.infiniteScroll);
                var parent = $element.parent();
                var scrollContainer = angular.element($attrs.scrollContainer || $window);
                var scrollTop = 0;
                var header = $attrs.header ? angular.element($attrs.header) : null;
                var placeholderTop = $compile('<div ng-style="{height: placeholderTopHeight}" class="placeholder"></div>')($scope);
                var startIndex = 0;
                var cachedPositions = [];
                var ignoreChanges = false;
                var headerHeight = 0;
                var windowEl = angular.element($window);
                var NON_HIDDEN_PAGE_COUNT = $routeParams.disableInfiniteScroll ? 0 : 3;
                var placeholderTopHeight = 0;
                var scrollTimeout = null;
                $scope.placeholderTopHeight = 0;
                // Make sure the re-ordering pages works correctly.
                // Basically make sure that the repeater item always
                // matches the inner infinite-scroll repeater item
                $scope.$watch('itemHolder.item', function (value) {
                    $scope[repeater.item] = value;
                });
                placeholderTop.prependTo(parent);
                $scope.$watch(repeater.collection, getSubItems);
                $scope.$watch($attrs.selectedIndex, topElementChanged);
                // Detect browser support for passive event listeners
                var supportsPassive = false;
                try {
                    var opts = Object.defineProperty({}, 'passive', {
                        get: function () {
                            supportsPassive = true;
                        }
                    });
                    window.addEventListener('test', null, opts);
                }
                catch (e) {
                    // Empty block
                }
                if (!$routeParams.disableInfiniteScroll) {
                    // Use our detect's results. Passive applied if supported, capture will be false either way.
                    scrollContainer[0]
                        .addEventListener('scroll', _.debounce(handleScroll, 500, {
                        leading: true,
                        trailing: true,
                        maxWait: 500
                    }), supportsPassive ? { passive: true } : false);
                }
                function getSubItems(collection) {
                    // Get the first NON_HIDDEN_PAGE_COUNT pages.
                    // Pages may be "hidden" (Widgets are still visible)
                    var pagesToFetch = 0;
                    var nonHiddenPages = 0;
                    for (var index = startIndex; nonHiddenPages <= NON_HIDDEN_PAGE_COUNT && collection[index]; index++, pagesToFetch++) {
                        var page = collection[index];
                        if (!page.meta || !page.meta.hidden || page.meta.showWidgets) {
                            nonHiddenPages++;
                        }
                    }
                    $scope.subItems = collection
                        .map(function (item, index) {
                        return {
                            item: item,
                            parentIndex: index
                        };
                    })
                        .slice(startIndex, startIndex + pagesToFetch);
                }
                function topElementChanged(index) {
                    setDefaultCachePositions(index);
                    predictNewPlaceholderHeights(index);
                    startIndex = index;
                    getSubItems($scope.$eval(repeater.collection));
                    if (ignoreChanges) {
                        return;
                    }
                    updateNewPlaceholderHeights();
                }
                function setDefaultCachePositions(index) {
                    if (!(angular.isDefined(cachedPositions[index]) || index === 0)) {
                        var lastCache = {
                            top: 0,
                            height: PAGE_DEFAULT_HEIGHT,
                            bottom: 0
                        };
                        for (var i = 0; i <= index; i++) {
                            var position = cachedPositions[i];
                            if (!position) {
                                position = cachedPositions[i] = {
                                    top: lastCache.bottom,
                                    height: lastCache.height,
                                    bottom: lastCache.bottom + lastCache.height
                                };
                            }
                            lastCache = position;
                        }
                    }
                }
                function updateNewPlaceholderHeights() {
                    headerHeight = header && header.height() || 0;
                    placeholderTop.height($scope.placeholderTopHeight);
                    $timeout(function () {
                        scrollContainer.scrollTop($scope.placeholderTopHeight === 0 ? 0 : ($scope.placeholderTopHeight + headerHeight - HEADER_HEIGHT_PADDING));
                    }, 0, false);
                }
                function predictNewPlaceholderHeights(index) {
                    placeholderTopHeight = (index === 0) ? 0 : (cachedPositions[index] && cachedPositions[index].top);
                    $scope.placeholderTopHeight = placeholderTopHeight;
                }
                function handleScroll() {
                    if (scrollTimeout) {
                        $timeout.cancel(scrollTimeout);
                    }
                    scrollTimeout = $timeout(function () {
                        ignoreChanges = false; // Debounces updateNewPlaceholderHeights() based on scroll stop.
                        if ($scope.$root) {
                            $scope.$root.$emit('reporting-scroll');
                        }
                    }, 250);
                    var currentSelectedIndex = $scope.$eval($attrs.selectedIndex);
                    cacheCurrentPositions();
                    // if user jumps to a page, update indices & short circuit the scroll handler
                    if ($scope.$eval($attrs.jumpToPage)) {
                        var pageId = $scope.$eval(repeater.collection)[currentSelectedIndex]._id;
                        $('#nav-' + pageId).addClass('selected-for-reorder');
                        return $scope.$evalAsync($attrs.selectedIndex + '=' + currentSelectedIndex + ';' +
                            $attrs.visibleIndex + '=' + currentSelectedIndex + ';' +
                            $attrs.jumpToPage + '= false;');
                    }
                    headerHeight = header && header.height() || 0;
                    var windowHeight = windowEl.height() - headerHeight;
                    var newScrollTop = scrollContainer.scrollTop() - headerHeight;
                    var delta = newScrollTop - scrollTop;
                    scrollTop = newScrollTop;
                    var foundOnScreenIndex = _.findIndex(cachedPositions, isOnScreen(scrollTop));
                    var foundVisibleIndex = _.findIndex(cachedPositions, isVisible(scrollTop, scrollTop + windowHeight / 4));
                    var firstOnScreenIndex = foundOnScreenIndex > -1 ? foundOnScreenIndex : 0;
                    var firstVisibleIndex = foundVisibleIndex > -1 ? foundVisibleIndex : firstOnScreenIndex;
                    if (firstOnScreenIndex !== currentSelectedIndex) {
                        if (!((firstOnScreenIndex > currentSelectedIndex && delta >= 0) || (firstOnScreenIndex < currentSelectedIndex && delta <= 0))) {
                            return; // Edge case: Scrolling up and down, repeatedly, extremely fast. Short circuit this action until scrolling has settled.
                        }
                        ignoreChanges = true;
                        $scope.$evalAsync($attrs.selectedIndex + '= ' + firstOnScreenIndex);
                    }
                    var currentVisibleIndex = $scope.$eval($attrs.visibleIndex);
                    if (firstVisibleIndex !== currentVisibleIndex) {
                        sideBarService.closeSideBar();
                        $scope.$evalAsync($attrs.visibleIndex + '=' + firstVisibleIndex);
                    }
                }
                function cacheCurrentPositions() {
                    parent.children('[ng-repeat]').each(function (i, child) {
                        child = angular.element(child);
                        var childScope = child.scope();
                        if (!childScope) {
                            return;
                        }
                        var parentIndex = childScope.itemHolder.parentIndex;
                        var childTop = child.offset().top - parent.offset().top;
                        var childHeight = child.height();
                        var childBottom = childTop + childHeight;
                        cachedPositions[parentIndex] = {
                            bottom: childBottom,
                            height: childHeight,
                            top: childTop
                        };
                    });
                }
                // Determines when to update 'Selected Index', when selected index changes, topElementChanged() is invoked.
                function isOnScreen(scrollTop) {
                    return function (child) {
                        return child.bottom >= scrollTop;
                    };
                }
                // Determines when to update 'Visible Index', when visible index changes, page nav will auto-select the page-in-view.
                function isVisible(scrollTop, windowCenter) {
                    return function (child) {
                        return (child.top >= scrollTop && child.top <= windowCenter) || child.bottom >= windowCenter;
                    };
                }
            }
        };
    }
    function parseRepeaterExpression(expression) {
        var matches = expression.match(NG_REPEAT_REGEXP);
        return {
            item: matches[1],
            collection: matches[2],
            trackBy: matches[4]
        };
    }
})(angular.module('reporting.dashboards.directives'));
